export default __webpack_public_path__ + "static/media/banner.939ef250.jpg";